import React from 'react';
const PremiumGallery16 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "10",
        height: "10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.75 0.625H1.875V1.5625H8.1875C8.32557 1.5625 8.4375 1.67443 8.4375 1.8125V8.125H9.375V1.25C9.375 0.904822 9.09518 0.625 8.75 0.625Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.625 3.125C0.625 2.77982 0.904822 2.5 1.25 2.5H6.875C7.22018 2.5 7.5 2.77982 7.5 3.125V8.75C7.5 9.09518 7.22018 9.375 6.875 9.375H1.25C0.904822 9.375 0.625 9.09518 0.625 8.75V3.125ZM5.80461 4.81434L5.02252 4.40754C4.92801 4.35838 4.80947 4.36542 4.7231 4.42531L4.0625 4.88347L3.4019 4.42531C3.31553 4.36542 3.19699 4.35838 3.10248 4.40754L2.32039 4.81434C2.2381 4.85715 2.1875 4.9357 2.1875 5.02065V6.07659C2.1875 6.14482 2.22022 6.20978 2.2774 6.25511L3.88455 7.52896C3.98603 7.6094 4.13897 7.6094 4.24045 7.52896L5.8476 6.25511C5.90478 6.20978 5.9375 6.14482 5.9375 6.07659V5.02065C5.9375 4.9357 5.8869 4.85715 5.80461 4.81434Z",
        fill: "currentColor"
    }));
PremiumGallery16.displayName = 'PremiumGallery16';
export default PremiumGallery16;

//# sourceMappingURL=16x16.js.map